import { ITabItem } from "@/shared/types";
import { ROUTER_PATHS } from "./router-paths";

// Back-Office (BO)
export const NAVIGATION_TABS_BO: Array<ITabItem> = [
  {
    id: 0,
    name: "Inventory",
    render: true,
    translateKey: "inventory",
    path: ROUTER_PATHS.backOffice.inventory.path,
  },
  {
    id: 1,
    name: "Client companies",
    render: true,
    translateKey: "clients",
    path: ROUTER_PATHS.backOffice.clientCompanies.path,
  },
  {
    id: 2,
    name: "Vendors",
    render: true,
    translateKey: "vendors",
    path: ROUTER_PATHS.backOffice.vendors.path,
  },
  // {
  //   id: 2,
  //   name: "Traders",
  //   render: true,
  //   translateKey: "traders",
  //   path: ROUTER_PATHS.backOffice.traders.path,
  // },
  {
    id: 3,
    name: "Users",
    render: true,
    translateKey: "users",
    path: ROUTER_PATHS.backOffice.users.path,
  },
  {
    id: 4,
    name: "Client orders",
    render: true,
    translateKey: "orders",
    path: ROUTER_PATHS.backOffice.clientOrders.path,
  },
  // {
  //   id: 2,
  //   name: "Research areas",
  //   render: true,
  //   translateKey: "research_areas",
  //   path: ROUTE_PATH.backOffice.researchAreas.path,
  // },
  // {
  //   id: 3,
  //   name: "Client orders",
  //   render: true,
  //   translateKey: "client_orders",
  //   path: ROUTE_PATH.backOffice.clientOrders.path,
  // },
  // {
  //   id: 4,
  //   name: "Vendor orders",
  //   render: true,
  //   translateKey: "vendor_orders",
  //   path: ROUTER_PATHS.backOffice.vendorOrders.path,
  // },
  {
    id: 5,
    name: "Non inventory requests",
    render: true,
    translateKey: "non_inventory_requests",
    path: ROUTER_PATHS.backOffice.nonInventory.path,
  },
  {
    id: 6,
    name: "Manege contact us",
    render: true,
    translateKey: "communication",
    path: ROUTER_PATHS.backOffice.contactUs.path,
  },
  {
    id: 7,
    name: "STUB",
    render: false,
    translateKey: "stub",
    path: "profile",
  },
];

// Client Area (CL)
export const NAVIGATION_TABS_CA: Array<ITabItem> = [
  {
    id: 0,
    name: "Inventory",
    render: true,
    translateKey: "inventory",
    path: ROUTER_PATHS.clientArea.inventory.path,
  },
  {
    id: 1,
    name: "Orders",
    render: true,
    translateKey: "orders",
    path: ROUTER_PATHS.clientArea.orders.path,
  },
  {
    id: 2,
    name: "Requests",
    render: true,
    translateKey: "requests",
    path: ROUTER_PATHS.clientArea.nonInventory.path,
  },
  {
    id: 3,
    name: "Contact us",
    render: true,
    translateKey: "contact_us",
    path: ROUTER_PATHS.clientArea.contactUs.path,
  },
  {
    id: 4,
    name: "Cart",
    render: true,
    translateKey: "cart",
    path: ROUTER_PATHS.clientArea.cart.path,
  },
  {
    id: 5,
    name: "STUB",
    render: false,
    translateKey: "stub",
    path: "profile",
  },
];
